/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Forms_Contact_Code_Trees_Create_TypeInputs */

const en_forms_contact_code_trees_create_type = /** @type {(inputs: Forms_Contact_Code_Trees_Create_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_forms_contact_code_trees_create_type = /** @type {(inputs: Forms_Contact_Code_Trees_Create_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Typ`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Forms_Contact_Code_Trees_Create_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const forms_contact_code_trees_create_type = /** @type {((inputs?: Forms_Contact_Code_Trees_Create_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Forms_Contact_Code_Trees_Create_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_forms_contact_code_trees_create_type(inputs)
	return de_forms_contact_code_trees_create_type(inputs)
});